<template>
  <card
    :class="['team-schedule-card', {'form-control-alternative': shadow},{'bg-success text-white': selected}]"
    bodyClasses="slim-card"
  >
    <div class="team-card-body">
      <div class="avatar-zone">
        <div class="avatar-group d-flex align-items-center">
          <div
            class="avatar rounded-circle"
            v-for="player in profiles" :key="player.id"
            v-tooltip="player.user.Name"
          >
            <img :src="getAvatarUrl(player.user)" />
          </div>
        </div>
      </div>
      <div class="team-info">
        {{team.Name}}
        <span class="division" v-if="week && team.movingFlight && week.movingWeek">
          <b>Moving Week:</b> {{team.movingFlight.name}}
        </span>
        <span class="division" v-else-if="week && team.flight && week.livePlayoff">
          <b>Flight:</b> {{team.flight.name}}
        </span>
        <span class="division" v-else-if="week && team.secondDivision && week.groupPlayoff">
          <b>Playoff:</b> {{team.secondDivision.name}}
        </span>
        <span class="division" v-else-if="team.division">
          <b>Division:</b> {{team.division.name}}
        </span>
      </div>
    </div>
  </card>
</template>
<script>
import AvatarHelper from '@/helpers/Avatars.js';

export default {
  name: 'TeamScheduleCard',
  props: {
    team: Object,
    selected: Boolean,
    shadow: Boolean,
    week: Object,
  },
  data() {
    return {
      profiles: [],
    };
  },
  mounted() {
    this.getPlayerProfiles();
    console.log(this.week, this.team);
  },
  methods: {
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
    getPlayerProfiles() {
      this.axios
        .get(`/teamprofiles?team_eq=${this.team.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.profiles = response.data;
        });
    },
  },
};
</script>
<style lang="scss">
  .slim-card{
    padding: 1rem;
  }
  .team-schedule-card{
    transition: all .25s;
  }
</style>
<style lang="scss" scoped>
  .avatar{
    margin-right: 1rem;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .avatar-group{
    .avatar{
      margin-left: -2rem;

      &:first-child{
        margin-left: 0;
      }
    }
  }

  .division{
    opacity: .5;
    font-size: .9rem;
  }

  .team-name-division{
    display: flex;
    flex-direction: column;
  }

  .team-card-body{
    display: flex;
    align-items: center;

    .team-info{
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
</style>
